<template>
  <b-navbar toggleable="lg" type="dark" variant="info">
    <img
      class="web-logo mx-auto"
      src="../../public/logo.png"
      @click="move"
      width="10%"
      alt="logo"
    />
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto mobileMenu">
        <b-nav-item class="text-right mOnly">
          <b-button class="changeName" @click="resetName()" id="resetName"
            >{{ $t("EditName") }}
          </b-button>
        </b-nav-item>
        <b-nav-item class="text-right"
          ><router-link :to="`/${$i18n.locale}/faq`"
            ><i
              ><img
                src="../../public/question-circle-regular-white.svg"
                alt="Question logo"
                class="font-icon"
            /></i>
            FAQ</router-link
          ></b-nav-item
        >
        <b-nav-item class="text-right"
          ><router-link :to="`/${$i18n.locale}/privacy-policy`"
            ><i
              ><img
                src="../../public/user-secret-solid.svg"
                alt="Secret logo"
                class="font-icon"
            /></i>
            {{ $t("privacy") }}</router-link
          >
        </b-nav-item>
        <b-nav-item class="text-right"
          ><router-link :to="`/${$i18n.locale}/legal-notice`"
            ><img
              src="../../public/flag-regular.svg"
              alt="Flag logo"
              class="font-icon"
            />
            {{ $t("legal") }}</router-link
          ></b-nav-item
        >
        <b-nav-item class="text-right">
          <span class="font-icon cursor-pointer" @click="showProModal">
            List2Go Pro
          </span>
        </b-nav-item>

        <b-nav-item class="text-right notM">
          <img :src="icon" alt="" width="20px" />
        </b-nav-item>



        <b-nav-item-dropdown
          :text="$t('language')"
          class="languages"
          id="langCh"
          right
        >
          <div id="black">
            <b-dropdown-item href="#" @click="setLocale('en')"
              ><img src="../../public/flag_en.png" alt="" width="22px" />
              EN</b-dropdown-item
            >
            <b-dropdown-item href="#" @click="setLocale('es')"
              ><img src="../../public/flag_es.png" alt="" width="22px" />
              ES</b-dropdown-item
            >
            <b-dropdown-item href="#" @click="setLocale('fr')"
              ><img src="../../public/flag_fr.png" alt="" width="22px" />
              FR</b-dropdown-item
            >
            <b-dropdown-item href="#" @click="setLocale('de')"
              ><img src="../../public/flag_de.png" alt="" width="22px" />
              DE</b-dropdown-item
            >
          </div>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
    <img
      class="logo"
      src="../../public/logo.png"
      @click="move"
      width="35%"
      alt="logo"
    />
    <i
      v-if="copy"
      class="text-white text-right icon align-middle"
      v-clipboard="() => url"
      v-clipboard:success="clipboardSuccessHandler"
      id="shareList"
      ><img
        src="../../public/share-solid.svg"
        alt="Share logo"
        class="font-icon-head border border-white rounded p-1"
    /></i>
  </b-navbar>
</template>

<script>
import nativeToast from "native-toast";
export default {
	name: "Navbar",
	props: {
		copy: Boolean,
		showProModalFn: Function
	},
	data() {
		return {
			//copy: false,
			url: window.location.href,
			icon: require("../../public/flag_en.png"),
		};
	},
	methods: {
		getUnits: function () {
			let lang = window.location.pathname.split("/");

			if (lang[1] == "en") {
				this.icon = require("../../public/flag_en.png");
			}
			if (lang[1] == "es") {
				this.icon = require("../../public/flag_es.png");
			}
			if (lang[1] == "fr") {
				this.icon = require("../../public/flag_fr.png");
			}
			if (lang[1] == "de") {
				this.icon = require("../../public/flag_de.png");
			}
		},

		move() {
			this.$router.push({ path: `/${this.$i18n.locale}/` });
		},
		privacy() {
			this.$router.push({ path: `/${this.$i18n.locale}/privacy-policy` });
		},
		legal() {
			this.$router.push({ path: `/${this.$i18n.locale}/legal-notice` });
		},
		donated() {
			// interact with db
			this.$store.dispatch("writeDonation");
		},
		showProModal() {
			if (this.showProModalFn) {
				this.showProModalFn();
			}
		},
		resetName() {
			let cookie =
        "userName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/de/list;";
			document.cookie = cookie;
			cookie =
        "userName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/en/list;";
			document.cookie = cookie;
			cookie =
        "userName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/fr/list;";
			document.cookie = cookie;
			cookie =
        "userName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/es/list;";
			document.cookie = cookie;
			cookie = "userName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/de;";
			document.cookie = cookie;
			cookie = "userName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/en;";
			document.cookie = cookie;
			cookie = "userName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/fr;";
			document.cookie = cookie;
			cookie = "userName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/es;";
			document.cookie = cookie;
			cookie = "userName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
			document.cookie = cookie;
			window.location.reload();
		},
		setLocale(locale) {
			if (locale == "en") {
				this.icon = require("../../public/flag_en.png");
			}
			if (locale == "es") {
				this.icon = require("../../public/flag_es.png");
			}
			if (locale == "fr") {
				this.icon = require("../../public/flag_fr.png");
			}
			if (locale == "de") {
				this.icon = require("../../public/flag_de.png");
			}
			this.$i18n.locale = locale;
			this.$router.push({
				params: { lang: locale },
			});
		},
		clipboardSuccessHandler() {
			if (navigator.share) {
				navigator
					.share({
						title: "You got a new List!",
						text: this.$parent.listName + " is your List2Go! Click to edit",
						url: window.location.href,
					})
					.then(() => {
						//console.log("Thanks for sharing!");
					})
					.catch((err) => {});
			} else {
				nativeToast({
					message: "Link Copied to Clipboard",
					position: "north-east",
					// Self destroy in 5 seconds
					timeout: 3000,
					type: "success",
				});
			}
		},
	},
	created: function () {
		this.getUnits();
	},
};
</script>

<style scoped>
.navbar-dark .navbar-nav .nav-link {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: #fff;
  border-color: #fff;
}
b-nav-item {
  color: #fff !important;
}

.web-logo {
  /*position: absolute;
      top: 50px;*/
  cursor: pointer;
}
.changeName {
  color: white;
  background-color: #fc6928;
  margin-top: 2px;
}
.icon {
  visibility: hidden;
}
.font-icon {
  height: 1rem;
  vertical-align: text-bottom;
}
.logo {
  display: none;
}

#black {
  color: black !important;
}
.mOnly {
  display: none;
}

@media screen and (max-width: 576px) {
  .icon {
    visibility: visible;
    position: absolute;
    right: 10px;
    top: 6.5px;
  }
  .logo {
    display: inline;
    margin-left: 33%;
    top: 5px;
  }
  .mOnly {
    display: inline;
  }
  .web-logo {
    display: none;
  }
  .languages a {
    position: fixed;
    left: 10px;
    top: 10px;
  }
  .notM {
    display: none;
  }
  .font-icon-head {
    height: 2.6rem;
  }

  .mobileMenu {
    margin-top: 30px;
  }
}
</style>